import { render } from "./foreignForm.vue?vue&type=template&id=7ab01160&scoped=true"
import script from "./foreignForm.vue?vue&type=script&lang=js"
export * from "./foreignForm.vue?vue&type=script&lang=js"

import "./foreignForm.vue?vue&type=style&index=0&id=7ab01160&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab01160"]])

export default __exports__